import React from 'react';
import * as Sentry from '@sentry/react';
import { t } from '@/i18n';

interface FallbackProps {
  error: Error;
  resetError: () => void;
}

function ErrorFallback({ resetError }: FallbackProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] p-8 text-center">
      <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
        {t('Something went wrong')}
      </h2>
      <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
        {t('An unexpected error occurred. Please try again.')}
      </p>
      <button
        onClick={resetError}
        className="mt-4 rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500"
      >
        {t('Try again')}
      </button>
    </div>
  );
}

export default function SentryErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <Sentry.ErrorBoundary fallback={({ error, resetError }) => (
      <ErrorFallback error={error as Error} resetError={resetError} />
    )}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
